import React from 'react';

import Icon from '../../Icon/Icon';
import DeprecatedDropdown from '../../../deprecated/DeprecatedDropdown/DeprecatedDropdown';
import DeprecatedDropdownItem from '../../../deprecated/DeprecatedDropdown/DeprecatedDropdownItem/DeprecatedDropdownItem';
import Checkbox from '../../Checkbox/Checkbox';
import { bemHelper } from '../../../helpers';
import useClickOutside from '../../../hooks/useClickOutside';
import { FilterType, CategoryType } from '../Search';

export interface FilterProps {
  /** onClick callback */
  onClick: (event?: Event) => void;
  /** Flag for activationg */
  isActive: boolean;
  /** Defines if there's a dropdown and maps its data to checkboxes */
  dropdownFilters: (FilterType | CategoryType)[];
  /** Aligns dropdown box to the right of the trigger */
  alignDropdown?: 'right';
  /** filterCallback callback. Requires filter.id and checkbox value as args */
  filterCallback: (id: string, checked: boolean) => void;
  /** Used to prevent the Dropdown to close when an item is selected */
  preventClose: boolean;
  /** Disables filter's dropdown trigger */
  isDisabled: boolean;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid': string | number;
}

export function Filter(props: FilterProps) {
  const [open, setOpen, ref] = useClickOutside();

  const hasFilterCategory = filter => Boolean(filter.category);

  const toggleDropdown = () => setOpen(!open);

  const handleClick = e => {
    e.stopPropagation();
    props.onClick(e);
    toggleDropdown();
  };

  const defineClassName = () => {
    const b = bemHelper();

    return b('ink-control--action', {
      open,
      active: props.isActive,
    });
  };

  const handleFilterCallback = (id, { target }) => props.filterCallback(id, target.checked);

  const renderCheckbox = filter => {
    return (
      <DeprecatedDropdownItem key={filter.id} isDisabled={filter.disabled}>
        <Checkbox
          id={filter.id}
          name={filter.name}
          label={filter.label}
          value={filter.value}
          isDisabled={filter.disabled}
          onChange={e => handleFilterCallback(filter.id, e)}
        />
      </DeprecatedDropdownItem>
    );
  };

  const renderDropdownItems = () => {
    return props.dropdownFilters.map(item => {
      if (hasFilterCategory(item)) {
        const i = item as CategoryType;
        return (
          <React.Fragment key={i.category}>
            <DeprecatedDropdownItem isHeader>{i.category}</DeprecatedDropdownItem>
            {i.filters?.map(filter => renderCheckbox(filter))}
          </React.Fragment>
        );
      }
      return renderCheckbox(item);
    });
  };

  return (
    <div ref={ref}>
      {!props.dropdownFilters.length ? (
        <button className={defineClassName()} onClick={handleClick} type="button" data-testid={props['data-testid']}>
          <Icon type="filter-1" />
        </button>
      ) : null}
      {props.dropdownFilters.length ? (
        <DeprecatedDropdown
          type="aura"
          align={props.alignDropdown}
          trigger={
            <div className="ink-control--action">
              <Icon type="filter-1" meaning="search filter" />
            </div>
          }
          isDisabled={props.isDisabled}
          preventClose={props.preventClose}
          data-testid={props['data-testid']}
        >
          {renderDropdownItems()}
        </DeprecatedDropdown>
      ) : null}
    </div>
  );
}

Filter.defaultProps = {
  onClick: () => {},
  isActive: false,
  dropdownFilters: [],
  filterCallback: () => {},
  preventClose: false,
  isDisabled: false,
  'data-testid': undefined,
};
